import type { FC } from 'react';

import { Icon } from '@zen/DesignSystem';

interface SuggestionPopoverProps {
  id: string;
  onAccept: (id: string) => void;
  onReject: (id: string) => void;
  proposedValueText: string;
}

export const SuggestionPopover: FC<SuggestionPopoverProps> = ({ id, proposedValueText, onAccept, onReject }) => {
  return (
    <div className="bg-sunset-base p-0.5">
      <div className="flex items-center px-2 gap-2 justify-between w-auto h-8 bg-white ">
        <div className="flex items-center gap-2">
          <span className="font-extrabold truncate max-w-40">{proposedValueText}</span>
        </div>

        <div className="flex items-center gap-2">
          <Icon onClick={() => onAccept(id)} className="text-navy-dark right-4 cursor-pointer" icon="zicon-tick" />
          <Icon onClick={() => onReject(id)} className="text-navy-dark right-4 cursor-pointer" icon="zicon-close" />
        </div>
      </div>
    </div>
  );
};
